/**
 * 菜单门户模板注册表
 * templateId 由前端定义，后端菜单只存整数 id
 * 仅包含门户栏目 historically 使用的模板
 */
import { resolveTemplateKey } from '@/components/home/utils/homeTemplates'

export const DEFAULT_TEMPLATE_ID = 1

export const PORTAL_MENU_TEMPLATE_IDS = [1, 2, 3, 4, 12, 28, 91, 92]

export const PORTAL_TEMPLATE_PICKER_ORDER = [3, 1, 4, 28, 2, 12, 91]

export const PRODUCT_CATALOG_TEMPLATE_IDS = [4, 28]

export function isProductCatalogTemplateId(templateId) {
  return PRODUCT_CATALOG_TEMPLATE_IDS.includes(Number(templateId))
}

export const CONTENT_PAGE_TEMPLATE_ID = 12
export const LEGACY_CONTENT_PAGE_TEMPLATE_IDS = [92]

export const PORTAL_TEMPLATES_BY_CONTENT_TYPE = {
  NEWS: [1],
  SOLUTION: [2],
  INTRODUCTION: [3, 12, 91],
  PRODUCT: [3, 4, 28]
}

export const MENU_TEMPLATE_REGISTRY = {
  1: { id: 1, key: 'FOCUS_CAROUSEL_LIST', name: '标签式', description: '顶部分类标签切换三级菜单 + 焦点文章 + 卡片网格', viewMode: 'tabs_l3_content', selectable: true, contentTypes: ['NEWS'] },
  2: { id: 2, key: 'TAB_PANEL_SWITCH', name: '卡片式', description: '大图卡片网格，展示方案标题与简介', viewMode: 'tab_panel_detail', selectable: true, contentTypes: ['SOLUTION'] },
  3: { id: 3, key: 'INTRO_CARD_GRID', name: '菜单式', description: '图标卡片网格，展示二级菜单与三级链接', viewMode: 'grid_l2_l3_links', selectable: true, contentTypes: ['INTRODUCTION', 'PRODUCT'] },
  4: { id: 4, key: 'CATEGORY_PRODUCT_ROW', name: '产品式', description: '分类图标栏 + 产品卡片网格', viewMode: 'category_bar_l2_pills', selectable: true, contentTypes: ['PRODUCT'] },
  12: { id: 12, key: 'CONTENT_PAGE', name: '内容式', description: '横幅 + 富文本正文（加入我们 / 法律声明 / 隐私保护）', viewMode: 'content_page', selectable: true, contentTypes: ['INTRODUCTION'] },
  28: { id: 28, key: 'CATEGORY_PORTAL_CARDS', name: '入口卡片', description: '大图分类卡片，展示分类标题与全部下级链接', viewMode: 'category_portal_cards', selectable: true, contentTypes: ['PRODUCT'] },
  91: { id: 91, key: 'CONTACT_FORM', name: '表单式', description: '横幅 + 在线留言表单', viewMode: 'form_single', selectable: true, contentTypes: ['INTRODUCTION'] },
  92: { id: 92, key: 'CONTENT_PAGE', name: '内容式', description: '横幅 + 富文本正文（旧版法律页 alias）', viewMode: 'content_page', selectable: false, contentTypes: ['INTRODUCTION'] }
}

export const PORTAL_TEMPLATE_KEYS = [
  'INTRO_CARD_GRID',
  'FOCUS_CAROUSEL_LIST',
  'CATEGORY_PRODUCT_ROW',
  'CATEGORY_PORTAL_CARDS',
  'TAB_PANEL_SWITCH',
  'CONTENT_PAGE',
  'CONTACT_FORM'
]

export const PORTAL_PAGE_DEFAULTS = {
  INTRODUCTION: 3,
  NEWS: 1,
  PRODUCT: 4,
  SOLUTION: 2
}

export function getTemplateEntry(templateId) {
  const id = Number(templateId)
  if (MENU_TEMPLATE_REGISTRY[id]) return MENU_TEMPLATE_REGISTRY[id]
  return MENU_TEMPLATE_REGISTRY[DEFAULT_TEMPLATE_ID]
}

export function resolveTemplateId(templateId) {
  const id = Number(templateId)
  if (LEGACY_CONTENT_PAGE_TEMPLATE_IDS.includes(id)) return CONTENT_PAGE_TEMPLATE_ID
  if (PORTAL_MENU_TEMPLATE_IDS.includes(id)) return id
  return DEFAULT_TEMPLATE_ID
}

/** 当前语言 localeStyles.templateId → 中文 localeStyles → 主表 */
export function resolveMenuTemplateId(menu, locale, defaultLocale = 'zh-CN') {
  const overlay = locale ? menu?.localeStyles?.[locale]?.templateId : null
  const fallback = defaultLocale ? menu?.localeStyles?.[defaultLocale]?.templateId : null
  const raw = overlay ?? fallback ?? menu?.templateId
  if (raw == null || raw === '') {
    return getDefaultTemplateIdForContentType(menu?.contentType || 'INTRODUCTION')
  }
  return resolveTemplateId(raw)
}

export function isContentPageTemplateId(templateId) {
  return resolveTemplateId(templateId) === CONTENT_PAGE_TEMPLATE_ID
}

export function resolveTemplateKeyById(templateId) {
  const entry = getTemplateEntry(templateId)
  return resolveTemplateKey(entry.key)
}

export function getDefaultTemplateIdForContentType(contentType) {
  return PORTAL_PAGE_DEFAULTS[contentType] ?? DEFAULT_TEMPLATE_ID
}

export function getTemplateOptionsForPicker(contentType) {
  const allowedIds = PORTAL_TEMPLATES_BY_CONTENT_TYPE[contentType] || PORTAL_MENU_TEMPLATE_IDS
  const orderMap = new Map(PORTAL_TEMPLATE_PICKER_ORDER.map((id, index) => [id, index]))
  return allowedIds
    .map((id) => MENU_TEMPLATE_REGISTRY[id])
    .filter((item) => item?.selectable)
    .sort((a, b) => (orderMap.get(a.id) ?? 999) - (orderMap.get(b.id) ?? 999))
}

export function isPortalMenuTemplateId(templateId) {
  return PORTAL_MENU_TEMPLATE_IDS.includes(Number(templateId))
}
